import { useRef } from 'react'

import { NAV_BRAND } from '@/config'

const useCountryShorthand = () => {
  const { current: countryShorthand } = useRef(NAV_BRAND.portal_is_at ? 'at' : 'de')
  return countryShorthand
}

export default useCountryShorthand
